module.exports = __webpack_public_path__ + "img/noninvasive-data-collection.67e022c8.jpg";